import {
  Box,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
} from "@chakra-ui/react";

import { useSubmitFeedbackMutation } from "@/features/user-manager/api/users-api";
import { useAppDispatch, useAppSelector } from "@/reduxHooks.ts";
import { closeModal } from "@/slices/modal-slice/modal-slice";
import { FEEDBACK_TYPE } from "@/utils/enums";

import { FeedbackModalBody } from "./feedback-modal-body";

interface FeedbackModalProps {
  onClose?: () => void;
}

const FeedbackModalTitle: Record<FEEDBACK_TYPE, string> = {
  [FEEDBACK_TYPE.SUBMIT_FEEDBACK]: "We Value Your Feedback!",
  [FEEDBACK_TYPE.REQUEST_FEEDBACK]: "How's Your Experience So Far?",
  [FEEDBACK_TYPE.TRAIL_ENDING]: "Your Trial is Ending Soon!",
};

export const FeedbackModal = ({ onClose }: FeedbackModalProps) => {
  const dispatch = useAppDispatch();
  const { modalProps } = useAppSelector((state) => state.rootReducer.modals);
  const [submitFeedback] = useSubmitFeedbackMutation();

  const { feedbackType } = modalProps as { feedbackType: FEEDBACK_TYPE };

  const hideModal = () => { 
    if (onClose) {
      onClose();
    } else {
      dispatch(closeModal());
    }
  };

  const handleClose = async () => {
    hideModal();
    if (feedbackType !== FEEDBACK_TYPE.SUBMIT_FEEDBACK) {
      try {
        await submitFeedback({ skip_feedback: true }).unwrap();
      } catch (error) {
        console.error("Failed to submit skipped feedback:", error);
      }
    }
  };

  return (
    <Modal isCentered isOpen={true} onClose={handleClose} size={"lg"}>
      <ModalOverlay />
      <ModalContent className="!p-0 !font-medium">
        <ModalBody>
          <Box className="p-5 text-lg">{FeedbackModalTitle[feedbackType]}</Box>
          <ModalCloseButton className="!right-0" />
          <FeedbackModalBody onClose={hideModal} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
